import { MessageCircle, Phone, ClipboardList } from "lucide-react";
import { SITE, openEnquiry } from "../config";
import { trackEvent } from "../analytics";

export const FloatingCtas = () => (
    <>
        <a
            href={SITE.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("whatsapp_click", { placement: "floating" })}
            className="fixed bottom-5 right-5 z-40 hidden h-14 w-14 items-center justify-center rounded-full bg-[#1fa855] text-white shadow-lg transition-transform duration-200 hover:scale-105 md:flex"
            aria-label="Chat on WhatsApp"
            data-testid="whatsapp-float-button"
        >
            <MessageCircle size={26} />
        </a>

        <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-[#ded8c6] bg-white md:hidden" data-testid="mobile-contact-bar">
            <a
                href={SITE.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent("whatsapp_click", { placement: "mobile_bar" })}
                className="flex items-center justify-center gap-1.5 py-3.5 text-[13px] font-bold uppercase tracking-wide text-[#178a45]"
                data-testid="mobile-bar-whatsapp"
            >
                <MessageCircle size={17} /> WhatsApp
            </a>
            <a
                href={SITE.phoneTel}
                onClick={() => trackEvent("call_click", { placement: "mobile_bar" })}
                className="flex items-center justify-center gap-1.5 border-x border-[#ded8c6] py-3.5 text-[13px] font-bold uppercase tracking-wide text-[#23231f]"
                data-testid="mobile-bar-call"
            >
                <Phone size={16} /> Call
            </a>
            <button
                onClick={openEnquiry}
                className="flex items-center justify-center gap-1.5 bg-[#8f7f45] py-3.5 text-[13px] font-bold uppercase tracking-wide text-white"
                data-testid="mobile-bar-enquire"
            >
                <ClipboardList size={16} /> Enquire
            </button>
        </div>
    </>
);
